// Utils
import create from '../utils/create';
import { addUnit } from '../utils';
import { BORDER } from '../utils/constant';
import { route } from '../utils/router'; // Mixins

import { ChildrenMixin } from '../mixins/relation'; // Components

export default create({
  render: function render() {
    var _obj;

    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.b({
        square: _vm.$parent.square
      }),
      style: _vm.style
    }, [_c('div', {
      class: _vm.b('content', (_obj = {
        center: _vm.$parent.center,
        square: _vm.$parent.square,
        clickable: _vm.$parent.clickable,
        surround: _vm.$parent.border && _vm.$parent.gutter
      }, _obj[_vm.BORDER] = _vm.$parent.border, _obj)),
      style: _vm.contentStyle,
      attrs: {
        "role": _vm.$parent.clickable ? 'button' : null,
        "tabindex": _vm.$parent.clickable ? 0 : null
      },
      on: {
        "click": _vm.onClick
      }
    }, [_vm._t("default", [_c('Icon', {
      class: _vm.b('icon'),
      attrs: {
        "name": _vm.icon,
        "dot": _vm.dot,
        "info": _vm.info,
        "size": _vm.$parent.iconSize
      }
    }), _c('span', {
      class: _vm.b('text')
    }, [_vm._v(_vm._s(_vm.text))])])], 2)]);
  },
  name: 'grid-item',
  mixins: [ChildrenMixin('TjGrid')],
  props: {
    url: String,
    replace: Boolean,
    to: [String, Object],
    dot: Boolean,
    text: String,
    icon: String,
    info: [Number, String]
  },
  data: function data() {
    return {
      BORDER: BORDER
    };
  },
  computed: {
    style: function style() {
      var _this$$parent = this.$parent,
          square = _this$$parent.square,
          gutter = _this$$parent.gutter,
          columnNum = _this$$parent.columnNum;
      var percent = 100 / columnNum + "%";
      var style = {
        flexBasis: percent
      };

      if (square) {
        style.paddingTop = percent;
      } else if (gutter) {
        var gutterValue = addUnit(gutter);
        style.paddingRight = gutterValue;

        if (this.index >= columnNum) {
          style.marginTop = gutterValue;
        }
      }

      return style;
    },
    contentStyle: function contentStyle() {
      var _this$$parent2 = this.$parent,
          square = _this$$parent2.square,
          gutter = _this$$parent2.gutter;

      if (square && gutter) {
        var gutterValue = addUnit(gutter);
        return {
          right: gutterValue,
          bottom: gutterValue,
          height: 'auto'
        };
      }
    }
  },
  methods: {
    onClick: function onClick(event) {
      this.$emit('click', event);
      route(this.$router, this);
    }
  }
});